import { defineMessages } from 'react-intl';

export const scope = 'app.components.SessionStageBuilder';

// Copy for the drill/practice-plan pickers. Legacy strings elsewhere in this builder
// remain hardcoded migration debt.
export const messages = defineMessages({
  evaluatePracticePlans: {
    id: `${scope}.evaluatePracticePlans`,
    defaultMessage: 'Evaluate the following practice plans:',
  },
  noPracticePlans: {
    id: `${scope}.noPracticePlans`,
    defaultMessage: 'No practice plans are available to this stage.',
  },
  createPracticePlan: {
    id: `${scope}.createPracticePlan`,
    defaultMessage: 'Create one here',
  },
  evaluateEvents: {
    id: `${scope}.evaluateEvents`,
    defaultMessage: 'and the following {events}:',
  },
  allowOverlapLabel: {
    id: `${scope}.allowOverlapLabel`,
    defaultMessage: 'Allow overlapping {sessions}',
  },
  limitSessionsLabel: {
    id: `${scope}.limitSessionsLabel`,
    defaultMessage: 'Limit {sessions} created for this stage',
  },
  limitSessionsHelp: {
    id: `${scope}.limitSessionsHelp`,
    defaultMessage: 'Each group gets its own {session}, up to this many. Stages sharing a day split the groups between them; otherwise this limit must cover every group before groupings can be approved.',
  },
  maxSessionsLabel: {
    id: `${scope}.maxSessionsLabel`,
    defaultMessage: 'Maximum {sessions}',
  },
  allowOverlapHelp: {
    id: `${scope}.allowOverlapHelp`,
    defaultMessage: 'Let {aSession} in this stage run at the same time as one from the previous stage, as long as they are at different {fields}. Two bookings on the same {field} always conflict.',
  },
});
